import CartSummary from './quickOrder/CartSummary';
import Item from './quickOrder/Item';

const ProductQuickShopTemplate = (props) => {
  const { products, settings, cart } = props;
  return (
    <>
      <div className="c7-product-quickorder">
        {products.map((product, index) => {
          const analytics = {
            view: 'Quick Shop',
            position: index + 1,
            totalProducts: products.length
          };
          return (
            <Item
              cart={cart}
              product={product}
              settings={settings}
              key={product.id}
              analytics={analytics}
            />
          );
        })}
      </div>
      <CartSummary cart={cart} settings={settings} />
    </>
  );
};

export default ProductQuickShopTemplate;
